<template>
  <div class="panel panel-gray wraper">
    <div class="panel-header">
      <span>Результаты поиска "{{$store.state.searchResults.term}}" ({{total}})</span>
      <q-btn round small flat icon="fa-search" color="secondary" @click="$router.push('/search')">
        <q-tooltip self="center left" anchor="center right" :delay="500">Новый поиск</q-tooltip>
      </q-btn>
    </div>
    <div class="panel-group" :class="{scroll: $route.meta.showLeft}">
          <result-item
              v-for="(item, index) in visibleItems"
              :index="index"
              :item="item"
              :key="item.id"
              :class="{selected: index === activeIndex}"
          />
        <my-scroll :handler="getMore" ref="myscroll">
          <q-spinner-dots :size="40" />
        </my-scroll>
      <q-btn
          v-back-to-top.animate="500"
          round
          color="teal-5"
          class="fixed-bottom-left"
          style="margin: 0 0 15px 15px"
      >
        <q-icon name="keyboard_arrow_up" />
      </q-btn>
    </div>
  </div>
</template>
<script>
import ResultItem from 'components/result-item.vue';
import MyScroll from 'components/my-scroll.vue';
import store from '../store';

export default {
  name: 'resultlist',
  components: {
    ResultItem,
    MyScroll,
  },
  data() {
    return {
      total: this.$store.state.searchResults.results.length,
      limit: 10,
    };
  },
  mounted() {
    this.$watch(
      'activeIndex',
      function (i) {
        this.$store.commit('setActive', i);
        this.$store.commit('setNext', (i < (this.items.length - 1)) && (i > -1) ? this.items[i + 1].id : null);
        this.$store.commit('setPrev', i > 0 ? this.items[i - 1].id : null);
        if (this.limit < (i + 1)) this.limit = i + 1;
        setTimeout(() => {
          if (this.visibleItems[i]) {
            const id = this.visibleItems[i].id;
            if (document.getElementById(id)) {
              document.getElementById(id).scrollIntoViewIfNeeded();
            }
          }
        }, 500);
      },
      { immediate: true },
    );
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.searchResults.results.length === 0) {
      next('/search');
    } else {
      store.commit('setTotal', store.state.searchResults.results.length);
      next();
    }
  },
  computed: {
    items() {
      return this.$store.state.searchResults.results;
    },
    visibleItems() {
      return this.items.slice(0, this.limit);
    },
    activeIndex() {
      return this.items.findIndex(c => c.id === this.$route.params.id);
    },
  },
  methods: {
    getMore() {
      if (this.limit < this.items.length) {
        this.limit = Math.min(this.limit + 10, this.items.length);
        return Promise.resolve(true);
      }
      return Promise.resolve(false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/result-list.vue